module.exports = __webpack_public_path__ + "img/sol_isol_pain4.1744e345.png";